import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useUserServices from '../../../hooks/useUserServices';
import { ServiceType } from '../../../api/web-api-client';

export interface BackToDashboardButtonProps {
    containerClassName?: string;
    className?: string;
}

const BackToDashboardButton = (props: BackToDashboardButtonProps) => {
    const services = useUserServices();
    const [to, setTo] = useState<string>('/dashboard');
    const {
        containerClassName = '', // default props
        className = '', // default props
    } = props;

    function routeToDashboard(serviceTypeToUse?: ServiceType): string {
        switch (serviceTypeToUse) {
            case ServiceType.TestingCalibration:
                return '/dashboard';
            case ServiceType.PatternApproval:
                return '/dashboard-ta';
            default:
                return '/';
        }
    }

    useEffect(() => {
        const defaultService = services.find((service) => service.isDefault);
        if (defaultService) {
            setTo(routeToDashboard(defaultService.service!));
        }
    }, [services]);

    return (
        <div className={`d-grid d-md-block ${containerClassName}`}>
            <Link
                data-testid='back-button'
                to={to}
                replace
                className={`btn btn-tertiary ${className}`}
            >
                <i className='icon-back me-1' aria-hidden='true' />
                Back to dashboard
            </Link>
        </div>
    );
};

// BackToDashboardButton.defaultProps = {
//     containerClassName: '',
//     className: '',
// };

export default BackToDashboardButton;
